import Fetch from "./index";

export const getAssistantVersions = async (assistantID, filters) => {
    if (!assistantID)
        return Promise.reject("missing assistant id");

    const filter = new URLSearchParams(filters).toString();

    return Fetch("/assistant/" + assistantID + "/version?" + filter)
}

export const getAssistantVersion = async ({assistantID, id}) => {
    if (!assistantID || !id)
        return Promise.reject("missing assistant id and version id");

    return Fetch("/assistant/" + assistantID + "/version/" + id )
}
